import serialize from "form-serialize";
import SendFormData from "../modules/SendFormData";

const mainForm = document.getElementById("main_form");
mainForm.addEventListener("submit", e => {
  e.preventDefault();

  const url = mainForm.getAttribute("action");
  const formData = serialize(mainForm, { hash: true, empty: true });

  new SendFormData({
    url,
    data: formData,
    successTitle: "Terima Kasih!",
    successMessage: "Kami akan menghubungi anda dalam waktu 24 jam",
    successCallback: () => {
      // Remove the '/booking' path. And redirect to the detail page again
      // But for "Contact Us". Because the splice make the array only 1 item
      // The redirect go to "" (empty), which is the redirect will be go to the "Contact Us" page again
      const url = window.location.pathname;
      const urlSplit = url.split("/");
      urlSplit.splice(urlSplit.length - 1, 1);
      window.location = urlSplit.join("/");
    }
  });
});
